// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewContainer_container__16dAt","subtitle":"ViewContainer_subtitle__Eyy0b","content":"ViewContainer_content__20BgG"};